import React from 'react';

import CoachingVideo from './CoachingVideo';
import useVideoPage from '../../hooks/useVideoPage';

function CoachingModulePage({ type = 'coachings' }) {
  useVideoPage();

  return (
    <main className="main white">
      <CoachingVideo type={type} />
    </main>
  );
}

export default CoachingModulePage;
